import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OpusEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import OpusAddressEditForm from '../Opus/OpusAddressEditForm/OpusAddressEditForm';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import VoiceAttributeEditForm from '../../VoiceAttributeEditForm/VoiceAttributeEditForm';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import lang from 'dojo/_base/lang';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import FloatingMenu from '../../../moreCore/UI/Floating/Menu';
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import FinderBaseV2 from '../../../WidgetCollection/FinderBase/FinderBaseV2';
import { ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";

class OpusEditorV2 extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    opusID: string;
    opusDisplayName: string;

    as_opus_titel;
    as_opus_subtitel;

    as_opus_titel_original: MdsLax<InstanceType<typeof Edit>>;
    as_opus_info_text_html: MdsLax<InstanceType<typeof Edit>>; //MultiLine -> HTML Editor when implemented
    as_opus_info_text_html_E: MdsLax<InstanceType<typeof Edit>>; //MultiLine -> HTML Editor when implemented
    as_duration_min: MdsLax<InstanceType<typeof NumberInput>>;
    as_ref_opus_status: MdsLax<InstanceType<typeof SearchSelect>>;
    //GROUP START
    as_note: MdsLax<InstanceType<typeof Edit>>; //MultiLine
    as_note_special: MdsLax<InstanceType<typeof Edit>>; //Multiline
    as_movements: MdsLax<InstanceType<typeof Edit>>; //Multiline
    as_opus_first_realease: MdsLax<InstanceType<typeof Edit>>; //MultiLine
    //GROUP END
    //GROUP START
    as_created_from: MdsLax<InstanceType<typeof Edit>>;
    as_created_until: MdsLax<InstanceType<typeof Edit>>;
    as_created_about: MdsLax<InstanceType<typeof Edit>>;
    //GROUP END

    as_EL_ht_addresses_opus_opus_store: MdsLax<InstanceType<typeof EntityStore<MainCatalogTypes.RelatedAddressTableEntry>>>;
    as_EL_ev_program_opus_store: MdsLax<InstanceType<typeof EntityStore<MainCatalogTypes.ProgramTableEntry>>>;




    private relatedAddressRowLayout: StaticTable.RowConfig = {
        colNamesInternal: ["ref_opus.gDisp_opus", "ref_address.gDisp_Name_Firstname", "ref_relation_type.description"],
        "attributes": ["ref_opus.gDisp_opus", "ref_address.gDisp_Name_Firstname", "ref_relation_type.description"],
        "colspans": [1, 1, 1],
        "headings": ["Werkbezeichnung", "Anzeigename", "Funktion"],
        widths: [null, null, null],
        alignmentsHeading: [null, null, null],
        alignmentsRow: [null, null, null]
    };

    private addressTableLayout: StaticTable.Layout = {
        name: "table",
        label: "label",
        rows: [(this as any).relatedAddressRowLayout],
        layoutStyle: "auto"
    }

    addressExpandableSection: MdsLax<InstanceType<typeof ExpandableSection>>;
    //newAddressComposerHintbox: HintBox;
    //newAddressFunctionSelect: SearchSelect;
    relatedAddressTableContainer: HTMLDivElement;
    relatedAddressTable: MdsLax<InstanceType<typeof StaticTable>>;
    /*addAddressButton: Button;*/
    opusAddressEditForm: MdsLax<InstanceType<typeof OpusAddressEditForm>>;

    private programRowLayout: StaticTable.RowConfig = {
        colNamesInternal: ["ref_ev_booking.ref_ev_project.gDisp_1", "ref_ev_booking.gDisp_1", "ref_ev_program_status.description", "note", "duration_min"],
        "attributes": ["ref_ev_booking.ref_ev_project.gDisp_1", "ref_ev_booking.gDisp_1", "ref_ev_program_status.description", "note", "duration_min"],
        "colspans": [1, 1, 1, 1, 1],
        "headings": [(this as any).translate("MainCatalogsEditor_Opus_ProgramTable_Label_Project"), (this as any).translate("MainCatalogsEditor_Opus_ProgramTable_Label_Booking"), (this as any).translate("MainCatalogsEditor_Opus_ProgramTable_Label_Status"), (this as any).translate("MainCatalogsEditor_Opus_ProgramTable_Label_Note"), (this as any).translate("MainCatalogsEditor_Opus_ProgramTable_Label_Duration")],
        widths: [null, null, null, null, null],
        alignmentsHeading: [null, null, null, null, null],
        alignmentsRow: [null, null, null, null, null]
    }

    private programTableLayout: StaticTable.Layout = {
        name: "table",
        label: "label",
        rows: [(this as any).programRowLayout],
        layoutStyle: "auto"
    }

    expandableSectionVAProgram: MdsLax<InstanceType<typeof ExpandableSection>>;
    programTableContainer: HTMLDivElement;
    programTable: MdsLax<InstanceType<typeof StaticTable>>;

    private notesRowLayout: StaticTable.RowConfig = {
        colNamesInternal: ["ref_note.description", "ref_note.ref_note_owner_status.description", "ref_note.c_conductor"],
        "attributes": ["ref_note.description", "ref_note.ref_note_owner_status.description", "ref_note.c_conductor"],
        "colspans": [1, 1, 1],
        "headings": [
            (this as any).translate("MainCatalogsEditor_Opus_NotesTable_Label_Description"),
            (this as any).translate("MainCatalogsEditor_Opus_NotesTable_Label_OwnerStatus"),
            (this as any).translate("MainCatalogsEdior_Opus_NotesTable_Label_Conductor")
        ],
        widths: [null, null, null],
        alignmentsHeading: [null, null, null],
        alignmentsRow: [null, null, null]
    }

    private notesTableLayout: StaticTable.Layout = {
        name: "table",
        label: "label",
        rows: [(this as any).notesRowLayout],
        layoutStyle: "auto",
        enableQuicksearch: true,
        quickSearchProperties: ["ref_note.c_conductor"],
        quickSearchPlaceholder: (this as any).translate("MainCatalogsEdior_Opus_NotesTable_Label_Conductor")
    }

    expandableSectionNotes: MdsLax<InstanceType<typeof ExpandableSection>>;
    notesTableContainer: HTMLDivElement;
    notesTable: MdsLax<InstanceType<typeof StaticTable>>;
    notesStore: MdsLax<InstanceType<typeof EntityStore<MainCatalogTypes.NotesTableEntry>>>;
    notesFinder: MdsLax<InstanceType<typeof FinderBaseV2>>;

    expandableSectionVoiceAttributeForm: MdsLax<InstanceType<typeof ExpandableSection>>;
    voiceAttributeEditForm: MdsLax<InstanceType<typeof VoiceAttributeEditForm>>;
    voiceAttributeEditFormContainer: HTMLDivElement;

    editMainContainer: HTMLDivElement;
    relatedAdressTableContainer: HTMLDivElement;

    dlg: MdsLax<InstanceType<typeof GenericDialog>>;

    errorMessage: HTMLDivElement;
    errorContainer: HTMLDivElement;

    addressButtonContainer: HTMLDivElement;

    private selectEntityDialogDataResponse: any = [];

    private relationTypes;
    private relationTypesFloatingMenu: MdsLax<InstanceType<typeof FloatingMenu>>;


    //Adress StaticTable Stuff
    private setupAddressTable(): void {
        /*this.newAddressFunctionSelect._loadListValues();*/
        this.relatedAddressTable = new StaticTable();
        this.relatedAddressTable.setRowClick(lang.hitch(this, this._onClickRow));
        this.relatedAddressTable.addLayout(this.addressTableLayout);
        this.relatedAddressTable.setCyAttribute("OpusEditorV2RelatedAddressTable");
        //this.relatedAddressTable.addLineConfig(this.relatedAddressTableLayout);
        this.relatedAddressTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditRelatedAddress));
        this.relatedAddressTable.addDefaultRowActionButton("delete", lang.hitch(this, this._onClickDeleteRelatedAddress));
        this.relatedAddressTable.addDefaultRowActionButton("rowsorting", lang.hitch(this, this._onClickRowSorting));
        this.relatedAddressTable.setupRowSorting("order");


        this.as_EL_ht_addresses_opus_opus_store = new EntityStore<MainCatalogTypes.RelatedAddressTableEntry>();
        this.as_EL_ht_addresses_opus_opus_store.on("change", lang.hitch(this, this._updateAddressData));
        this.as_EL_ht_addresses_opus_opus_store.on("change", lang.hitch(this, this._onChangeStore, this.as_EL_ht_addresses_opus_opus_store, this.addressExpandableSection));
        //this.as_EL_ht_addresses_opus_opus_store.on("deleted", lang.hitch(this, this._updateOrder));

        this.relatedAddressTable.setupFromStore(this.as_EL_ht_addresses_opus_opus_store);

        this.UiModder.domConstruct.place(this.relatedAddressTable.domNode, this.relatedAddressTableContainer);
    }

    private setupProgramTable(): void {
        this.programTable = new StaticTable();
        this.programTable.addLayout(this.programTableLayout);

        this.as_EL_ev_program_opus_store = new EntityStore<MainCatalogTypes.ProgramTableEntry>();
        this.as_EL_ev_program_opus_store.on("change", lang.hitch(this, this._onChangeStore, this.as_EL_ev_program_opus_store, this.expandableSectionVAProgram));

        this.programTable.setupFromStore(this.as_EL_ev_program_opus_store);

        this.programTable.setRowClick(lang.hitch(this, this._openProgramView));
        this.programTable.setCyAttribute("OpusEditorV2ProgrammTable");

        this.UiModder.domConstruct.place(this.programTable.domNode, this.programTableContainer);
    }

    private setupNotesTable(): void {
        this.notesTable = new StaticTable();
        this.notesTable.addLayout(this.notesTableLayout);

        this.notesStore = new EntityStore<MainCatalogTypes.NotesTableEntry>();
        //this.notesStore.on("change", lang.hitch(this, this._onChangeStore, this.notesStore, this.expandableSectionNotes));

        this.notesTable.setupFromStore(this.notesStore);

        this.notesTable.setRowClick(lang.hitch(this, this._openNotesView));

        this.notesTable.setCyAttribute("OpusEditorV2NotesTable");


        this.UiModder.domConstruct.place(this.notesTable.domNode, this.notesTableContainer);
    }

    private setupNotesFinder(): void {

        this.notesFinder = new FinderBaseV2();
        this.notesFinder.on("tableCreated", lang.hitch(this, this._onFinderTableCreated))

        this.notesFinder.setupFinderWithCallfunctions(
            "Webtool__MainCatalogsEditor_GetNotesFilterOptionsJSON",
            "Webtool__MainCatalogsEditor_GetNotesTable",
            lang.hitch(this, this._openNotesView),
            null,
            null,
            [
                { name: "entityID", value: this.entityId }
            ]
        );


        this.notesFinder.placeAt(this.notesTableContainer);
    }

    private _onFinderTableCreated(table: MdsLax<InstanceType<typeof StaticTable>>) {
        this.expandableSectionNotes.setMarking(table.getData().length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onChangeStore(store: MdsLax<InstanceType<typeof EntityStore<any>>>, expander: MdsLax<InstanceType<typeof ExpandableSection>>) {
        expander.setMarking(store.getCurrentCompleteList().length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<any>): boolean {
        cell.contentnode.innerHTML = cell.value;
        return false;
    }

    private _openProgramView(row): void {
        var entityView: MdsLax<InstanceType<typeof GenericEntityView>> = new GenericEntityView();

        var entity = row.rowGroup.entity;

        entityView.setup(entity.ID, entity.Classname, entity.$Displayname, "$Displayname", null, null, "MainCatalogsEditor");
    }

    private _openNotesView(row): void {
        var entityView = new GenericEntityView();

        var entity = row.rowGroup.entity;

        entityView.setup(entity.ID, entity.Classname, entity.description, "description", null, null, "MainCatalogsEditor");
    }

    private _onClickRowSorting() {
    }

    private _onClickDeleteRelatedAddress(e: StaticTable.StaticTableRowGroup<MainCatalogTypes.RelatedAddressTableEntry>): void {
        this.as_EL_ht_addresses_opus_opus_store.deleteEntry(e.entity);
    }

    private _onClickRow(row: StaticTable.StaticTableRow<MainCatalogTypes.RelatedAddressTableEntry>) {
        this._openEditForm(row.rowGroup.entity);
    }

    private _onClickEditRelatedAddress(rowGroup: StaticTable.StaticTableRowGroup<MainCatalogTypes.RelatedAddressTableEntry>): void {
        this._openEditForm(rowGroup.entity);
    }

    private _openEditForm(entry: MainCatalogTypes.RelatedAddressTableEntry) {
        this.dlg = new GenericDialog();


        this.dlg.closeOnEnter = false;
        this.dlg.destroyOnClose = true;
        this.dlg.keepOpen = true;
        this.dlg.enableContentOverflow(true);

        this.opusAddressEditForm = new OpusAddressEditForm();
        this.opusAddressEditForm.setupForm(entry);

        this.dlg.show(this.opusAddressEditForm, entry.ref_address.gDisp_Firstname_Name, null, null, "okcancel", lang.hitch(this, this._onOpusAddressEditFormDlgResponse, this.dlg, this.opusAddressEditForm));
    }

    private _onOpusAddressEditFormDlgResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof OpusAddressEditForm>>, response: number) {
        if (response >= 1) {
            var formData = form.getData();
            if (form.getIsDirty()) {
                this.as_EL_ht_addresses_opus_opus_store.changeEntry(formData);
            }
        }
        dlg.close(-1, true);
    }

    private _onClickOpenAddressSED(e, entryData: { ID: string, description: string }): void {
        this.loadSelectEntityDialog(e,
            "selectVtAddresses",
            lang.hitch(this, this._onCallbackSED, entryData),
            null,
            entryData
        );
    }

    private _onCallbackSED(entryData: { ID: string, description: string }, mode: string, data, items) {
        if (items) {
            items.forEach((item, index) => {
                var newRelatedAddress: MainCatalogTypes.RelatedAddressTableEntry = {
                    ID: null,
                    ref_opus: {
                        ID: this.getAttributeValue("ID"),
                        gDisp_opus: this.getAttributeValue("gDisp_opus"),
                    },
                    ref_address: item.entry.data as any,
                    ref_relation_type: entryData as any,
                    order: 0 - index
                }
                this.as_EL_ht_addresses_opus_opus_store.addEntry(newRelatedAddress);
                this._updateOrder();
            });
        }


    }

     _updateOrder() {
         var tableData: Array<MainCatalogTypes.RelatedAddressTableEntry> = lang.clone(this.relatedAddressTable.getData() as Array<MainCatalogTypes.RelatedAddressTableEntry>);
        for (var i = 0; i < tableData.length; i++) {
            var tempData = tableData[i];
            tempData.order = i + 1;
            this.as_EL_ht_addresses_opus_opus_store.addEntry(tempData);
            this.as_EL_ht_addresses_opus_opus_store.changeEntry(tempData, true);
         }


         //this.setAttributeValue("addressCompleteList", this.as_EL_ht_addresses_opus_opus_store.getCurrentCompleteList());
    }

    private _updateAddressData(e?): void {
        this.setAttributeValue("addressDiffData", this.as_EL_ht_addresses_opus_opus_store.getDiffData());
    }

    //private _onChangeAddAddress(): void {
    //    var activateButton = this.newAddressComposerHintbox.getValue() && this.newAddressFunctionSelect.getValue()
    //    this.disableNode(this.addAddressButton, !activateButton);
    //}

    protected _onChanged(attribute: string, value: any) {
        super._onChanged.apply(this, arguments as any);
    }

    private _loadRelationTypeValues() {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool__MainCatalogsEditor_GetRelationTypesListValues",
            {},
            lang.hitch(this, this._onGetRelationTypesListValuesResponse),
            lang.hitch(this, this._onGetRealtionsTypesListValuesError)
        )}

    private _onGetRelationTypesListValuesResponse(response) {
        this.StandbyStop();

        this.relationTypes = response;
    }

    private _onGetRealtionsTypesListValuesError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onClickDropdownButton(e) {
        //this.relationTypesFloatingMenu.open(e)
        //this.relationTypesFloatingMenu = new FloatingMenu();

        this.relationTypesFloatingMenu = new FloatingMenu();
        this.relationTypes.forEach((relationType) => {
            this.relationTypesFloatingMenu.addEntry({
                callback: lang.hitch(this, this._onClickMenuEntry, { ID: relationType.ID, description: relationType.description }),
                label: relationType.$Displayname,
                groupname: relationType.ref_relation_group.description,
                heading: relationType.ref_relation_group.description
            });
        });

        this.relationTypesFloatingMenu.open(e, null, this.translate("MainCatalogsEditor_OpusEditor_Heading_AddAddress"));
    }

    private _onClickMenuEntry(entryData: { ID: string, description: string }, e) {
        this._onClickOpenAddressSED(e, entryData);
    }

    private _onChange_VoiceAttributeEditForm() {
        let hasData = this.voiceAttributeEditForm.hasData();
        this.expandableSectionVoiceAttributeForm.setMarking(hasData ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }


    //Default MainCataLogs Stuff
    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        if (!this.notesFinder) this.setupNotesFinder();

        this._onChange_VoiceAttributeEditForm();

        this.as_EL_ht_addresses_opus_opus_store.setup(this.getCurrentData().EL_ht_addresses_opus_opus);
        this.as_EL_ev_program_opus_store.setup(this.getCurrentData().EL_ev_program_opus);
        //this.notesStore.setup(this.getCurrentData().EL_ht_notes_opus_opus);

        this.relatedAddressTable.setupFromStore(this.as_EL_ht_addresses_opus_opus_store);
        this.programTable.setupFromStore(this.as_EL_ev_program_opus_store);
        //this.notesTable.setupFromStore(this.notesStore);
        this.selectEntityDialogDataResponse = [];

        this.addressExpandableSection.setMarking(this.getCurrentData().EL_ht_addresses_opus_opus.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.expandableSectionVAProgram.setMarking(this.getCurrentData().EL_ev_program_opus.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.expandableSectionNotes.setMarking(this.getCurrentData().EL_ht_notes_opus_opus.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        //this.newAddressFunctionSelect.setValue(null);
        //this.newAddressComposerHintbox.setValue(null);

        this._updateOrder();
    }

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected _setEntityClass(): void {
        this.entityClass = MainCatalogs_Classes.Opus;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        this.setupAddressTable();
        this.setupProgramTable();

        //this.setupNotesTable();
        //this.setupNotesFinder();

        this.setAttributeValue("addressDiffData", {
            changed: [],
            deleted: [],
            new: [],
        });

        this.voiceAttributeEditForm.on("change", lang.hitch(this, this._onChange_VoiceAttributeEditForm));
        //this.expandableSectionVoiceAttributeForm.setMarking(ExpandableSectionMarkings.hasContent);

        //this.newAddressComposerHintbox.addInlineButton(lang.hitch(this, this._onClickOpenAddressSED));
        this.SEDconfigCallfunction = "Webtool__MainCatalogsEditor_OpusEditor_SED_GetConfig";

        //this.disableNode(this.addAddressButton, true);

        this._loadRelationTypeValues();
        this.as_ref_opus_status.loadListValues(null, false);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);



    }
}

export default mdsWidget(OpusEditorV2);
